const moment = require('moment');

function isISODate (value) {
  return moment(value, [moment.ISO_8601], true).isValid();
}

module.exports = isISODate;
